import React from 'react';
import { ReactSVG } from 'react-svg';
import StarSvg from '../svg/star.svg';
import { styles } from '../styles/styles';
import { EM_DASH } from '../utils/format.js';

const StarRating = ({ rating }) => {
  // Three states, not two.
  //
  //   null / non-numeric -> we could not compute a rating at all, because the
  //                         market is unpriced or the model produced nothing.
  //   0                  -> we computed one, and it is no edge.
  //   1..3               -> a real rating.
  //
  // Rendering nothing for both of the first two would be an improvement on the
  // old behaviour (which awarded three stars to a market that did not exist) but
  // still leaves "we have no data" indistinguishable from "we looked and there
  // is no edge here". Absence gets its own mark.
  //
  // The numeric guard is on integer-ness, not just zero: [...Array(NaN)] and
  // [...Array(2.5)] throw RangeError, and [...Array(null)] silently renders one
  // star out of no data at all.
  if (!Number.isInteger(rating)) {
    return (
      <span
        className="star-unknown"
        style={styles.unknown}
        title="No price for this market, so no edge can be calculated"
      >
        {EM_DASH}
      </span>
    );
  }

  if (rating <= 0) {
    return <span></span>;
  }

  return (
    <span className="star-container">
      {[...Array(rating)].map((_, i) => (
        <ReactSVG 
          key={i} 
          src={StarSvg} 
          wrapper="span"
          beforeInjection={(svg) => {
            svg.setAttribute('style', `width: ${styles.star.width}; height: ${styles.star.height};`);
            svg.setAttribute('fill', styles.star.color);
          }}
        />
      ))}
    </span>
  );
};

export { StarRating };